import React from 'react';
import { Dropdown } from 'react-bootstrap';
import CardDropdown from './CardDropdown';
import PropTypes from 'prop-types';

const TableRowAction = ({ onCLickEdit, onCLickDelete }) => {
  return (
    <CardDropdown>
      <div className="py-2">
        <Dropdown.Item onClick={onCLickEdit}>Edit</Dropdown.Item>
        <Dropdown.Item className="text-danger" onClick={onCLickDelete}>
          Delete
        </Dropdown.Item>
      </div>
    </CardDropdown>
  );
};

TableRowAction.propTypes = {
  onCLickEdit: PropTypes.func,
  onCLickDelete: PropTypes.func
};

export default TableRowAction;
